module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/redux-form/~/is-promise/index.js
// module id = 516
// module chunks = 0